<template>

<div class="corpo-pagina">

    <div class="row row-text">
      <div class="col s12">
        <h1 v-html="translation('item.menu.quat')"></h1>
      </div>
    </div>
<div class="divider"></div>
    <div class="row row-text">
      <div class="col s12">
        <p v-html="translation('pagina.noleggio.ipad')"></p>
      </div>
    </div>
</div>

</template>

<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'

export default {
  name: 'PrivacyView', // Nome componente più specifico
  data () {
    return {
      translationStore: translationStore
    }
  },

  computed: {
    translation () {
      return translationStore.getters.traduzione
    }

  },

  async mounted () {
    loadingStore.commit('setLoading', false)
  },

  methods: {},

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>
